import {
  format,
  parseISO,
  isValid,
  isToday,
  isTomorrow,
  FormatOptions,
} from "date-fns";
import { es } from "date-fns/locale";

const options: FormatOptions = { locale: es };

export function parseDateISO(dateISO: string, context = "a las"): string {
  const date = parseISO(dateISO);

  if (!isValid(date)) {
    throw new Error(`Invalid date format: ${dateISO}`);
  }

  const day = parseDay(date);
  const time = format(date, "h aaa", options);

  return `${day} ${context} ${time}`;
}

function parseDay(date: Date) {
  if (isToday(date)) return "hoy";
  if (isTomorrow(date)) return "mañana";
  return format(date, "'el' EEEE d", options);
}
